<mat-form-field
  class="date-range-input-picker coin-form-field-outline coin-form-field-outline--{{
    matFormFieldClass()
  }} coin-form-field-outline--date-range no-margin"
  matTooltipClass="error-tooltip"
  appearance="outline"
  floatLabel="always"
  [matTooltip]="errorTooltip()"
  [matTooltipDisabled]="!touched()">
  @if (label()) {
    <mat-label>{{ label() }}</mat-label>
  }
  <mat-date-range-input
    [rangePicker]="rangePicker"
    [dateFilter]="dayFilter"
    [min]="min()"
    [max]="max()"
    [disabled]="disabled()">
    <input
      #start
      matStartDate
      [style.font-family]="boldValue() && value?.start ? 'Siemens Sans Bold !important' : null"
      [placeholder]="startPlaceholder()"
      [value]="$safeNavigationMigration(value?.start)"
      (dateChange)="onInputChange('start', $event.value)"
      (blur)="onInputBlur('start', start.value)" />
    <input
      #end
      matEndDate
      [style.font-family]="boldValue() && value?.end ? 'Siemens Sans Bold !important' : null"
      [placeholder]="endPlaceholder()"
      [value]="$safeNavigationMigration(value?.end)"
      (dateChange)="onInputChange('end', $event.value)"
      (blur)="onInputBlur('end', end.value)" />
  </mat-date-range-input>
  <mat-icon
    aria-label="calendar-button"
    matSuffix
    (click)="$event.stopPropagation(); rangePicker.open()">
    date_range
  </mat-icon>

  <mat-date-range-picker
    #rangePicker
    (closed)="onPickerClosed()"></mat-date-range-picker>
</mat-form-field>
